import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '@ess-front/authorization';

@Component({
  selector: 'ess-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  imports: [
    MatIcon,
    MatListItem,
    MatNavList,
    MatSidenavModule,
    MatToolbar,
    RouterLink,
    RouterOutlet,
    MatIconButton,
    MatMenuModule,
  ],
})
export class BaseComponent {
  constructor(private readonly authService: AuthService) {}

  logOut(): void {
    this.authService.logout();
  }
}
